import type { FEATURE } from '~/common/enums/feature.enum';
import type { TreatmentWithConfig } from '~/domains/feature-flags/types';

import { useTreatments } from './useTreatments';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTreatment = <F extends FEATURE, CF = any>(
  featureFlagName: F
): {
  isReady: boolean;
  isSettled: boolean;
  treatment: TreatmentWithConfig | null;
} => {
  const { isReady, isSettled, treatments } = useTreatments<F, Record<F, CF>>([featureFlagName]);

  return {
    isReady,
    isSettled,
    treatment: treatments[featureFlagName] || null,
  };
};
